import auth from '@/middleware/auth';
import {create, read, update} from "../middleware/index";
import env from '../env'

const path = env.route.path;
const name = env.route.name;

export default [
    {
        path: `/${path}`,
        name: name,
        meta: {
            layout: 'main',
            middleware: [auth]
        },
        component: () => import('../views/MainView.vue')
    },
    {
        path: `/${path}/create`,
        name: `${path}.create`,
        meta: {
            layout: 'main',
            middleware: [auth, create]
        },
        component: () => import('../views/CreateView.vue')
    },
    {
        path: `/${path}/:id/show`,
        name: `${path}.show`,
        meta: {
            layout: 'main',
            middleware: [auth, read]
        },
        component: () => import('../views/ShowView.vue')
    },
    {
        path: `/${path}/:id/edit`,
        name: `${path}.edit`,
        meta: {
            layout: 'main',
            middleware: [auth, update]
        },
        component: () => import('../views/EditView.vue')
    }
];
